<template>
    <div class="key-config-wrapper">
        <el-row class="key-header-row">
          <label style="margin-right: 12px; font-weight: 600; font-size: 15px; color: #303133; min-width: 52px; display: inline-block;" v-html="keyname"></label>
          <el-radio-group v-model="keyradio" @change="fucChange()">
            <el-radio :label="1">{{ $t('keyConfig.keyDes1') }}</el-radio>
            <el-radio :label="2">{{ $t('keyConfig.keyDes2') }}</el-radio>
            <el-radio :label="3">{{ $t('keyConfig.keyDes3') }}</el-radio>
            <el-radio :label="4">{{ $t('keyConfig.keyDes4') }}</el-radio>
            <el-radio :label="5" v-if="stringshow">{{ $t('keyConfig.keyDes5') }}</el-radio>
            <template v-if="mouseoptshow">
              <el-radio :label="6">{{ $t('keyConfig.keyDes6') }}</el-radio>
            </template>
          </el-radio-group>
          <div class="quick-toggle-col">
            <el-button
              size="large"
              :type="quickPanelOpen ? 'warning' : 'primary'"
              :icon="quickPanelOpen ? 'el-icon-arrow-up' : 'el-icon-lightning'"
              class="quick-toggle-btn"
              @click="quickPanelOpen = !quickPanelOpen">
              {{ $t('keyConfig.quickSetting') }}{{ quickPanelOpen ? '' : '...' }}
            </el-button>
            <span class="quick-toggle-hint">{{ $t('keyConfig.quickToggleHint') }}</span>
          </div>
        </el-row>
        <el-row v-show="quickPanelOpen" class="quick-setting-row">
          <div class="quick-setting-card">
            <div class="qs-header">
              <div class="qs-title">
                <i class="el-icon-lightning" style="color: #E6A23C; margin-right: 6px;"></i>
                <span>{{ $t('keyConfig.quickSetting') }}</span>
              </div>
              <el-input
                v-model="quickSearch"
                class="qs-search"
                size="small"
                clearable
                :placeholder="$t('keyConfig.quickSearchPlaceholder')"
                prefix-icon="el-icon-search">
              </el-input>
            </div>
            <div class="qs-categories">
              <el-button
                v-for="cat in quickCategories"
                :key="cat.value"
                size="mini"
                :type="quickCategory === cat.value ? 'primary' : ''"
                :plain="quickCategory !== cat.value"
                @click="quickCategory = cat.value">
                {{ cat.label }}
              </el-button>
            </div>
            <div class="qs-grid">
              <div
                v-for="item in filteredQuickList"
                :key="item.id"
                class="qs-card"
                :class="{ 'qs-card-active': quickActiveId === item.id }"
                :title="item.name + '（' + item.hotkey + '）'"
                @click="applyQuickSetting(item)">
                <div class="qs-card-name">{{ item.name }}</div>
                <div class="qs-card-hotkey">{{ item.hotkey }}</div>
              </div>
            </div>
            <div class="qs-footer-tip">
              <i class="el-icon-info" style="color: #909399; margin-right: 4px;"></i>
              {{ $t('keyConfig.quickTip2') }}
            </div>
          </div>
        </el-row>
      <el-row>
        <el-select v-model="funcselectvalue" :placeholder="$t('keyConfig.select')" v-if="funcselectshow" style="width:200px">
          <el-option
            v-for="item in funcoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="mediaselectvalue" :placeholder="$t('keyConfig.select')" v-if="mediaselectshow" style="width:200px">
          <el-option
            v-for="item in mediaoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <div v-if="mediaselectshow" style="margin-top: 6px; color: #E6A23C; font-size: 12px;">
          <i class="el-icon-warning" style="margin-right: 4px;"></i>{{ $t('keyConfig.mediaKeyTip') }}
        </div>
        <el-input style="width:70px" type="text" v-model="text1" maxlength="1" show-word-limit v-if="input1show"></el-input>
        <span v-if="input1show" style="margin-left: 8px; font-size: 22px; font-weight: 900; vertical-align: middle;">
          <i class="el-icon-check" :style="{color: isText1Valid ? '#67C23A' : '#C0C4CC'}"></i>
          <span style="margin-left: 4px; color: #909399; font-size: 12px;">{{ $t('keyConfig.normalKeyTip') }}</span>
        </span>
        <div v-if="input1show" class="normal-key-lowercase-hint">
          <i class="el-icon-info"></i>{{ $t('keyConfig.normalKeyLowercaseHint') }}
        </div>       
        <el-input style="width:350px" type="text" v-model="text2" :maxlength="stringsize" show-word-limit clearable v-if="input2show"></el-input>
        <el-checkbox v-if="input2show" v-model="stringcheck" style="margin-left: 20px;" >{{ stringchecktxt }}</el-checkbox>     
        <div v-if="mouseshow">
        <el-select v-model="mouseselectvalue" :placeholder="$t('keyConfig.select')" v-if="mouseselectshow" style="width:200px" @change="mousecheckchange()">
          <el-option
            v-for="item in mouseoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <label style="margin-left: 20px;">{{ mouseinputtxt }}</label>
        <el-input-number v-if="mouseinputshow" v-model="mouseinput" :step="1" :min=1 :max=120></el-input-number>
        <el-input-number v-if="mousescroolshow" v-model="mousescrool" :step="1" :min=1 :max=5></el-input-number>
        <el-checkbox v-if="mousecheckshow" v-model="mousecheck" @change="mousecheckpress1()" style="margin-left: 20px;" >{{ mousechecktxt }}</el-checkbox>
        <el-checkbox v-if="mousepresscheckshow" v-model="mousepresscheck" @change="mousecheckpress2()" style="margin-left: 20px;" >{{ mousepresschecktxt }}</el-checkbox>
        <el-checkbox v-if="mousedoubleshow" v-model="mousedouble" @change="mousedoublechange()" style="margin-left: 20px;">{{ mousedoubletxt }}</el-checkbox>
        </div>
      </el-row>
      <div v-if="mixshow">
      <el-row v-if="mixcountarray[0]">
        <el-select v-model="mixfuncselectvalue[0]" :placeholder="$t('keyConfig.select')" style="width:200px" v-if="mixshowarray[0]">
          <el-option
            v-for="item in mixfuncoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input style="width:70px" type="text" v-model="mixtext[0]" maxlength="1" show-word-limit v-if="!mixshowarray[0]"></el-input>
        <div style="display:inline-block;" v-if="mixcountarray[1]">
        +
          <el-select v-model="mixfuncselectvalue[1]" :placeholder="$t('keyConfig.select')" style="width:200px"  v-if="mixshowarray[1]">
          <el-option
            v-for="item in mixfuncoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input style="width:70px" type="text" v-model="mixtext[1]" maxlength="1" show-word-limit v-if="!mixshowarray[1]"></el-input>  
        </div>
        <div style="display:inline-block;" v-if="mixcountarray[2]">
        +
        <el-select v-model="mixfuncselectvalue[2]" :placeholder="$t('keyConfig.select')" style="width:200px" v-if="mixshowarray[2]">
          <el-option
            v-for="item in mixfuncoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input style="width:70px" type="text" v-model="mixtext[2]" maxlength="1" show-word-limit v-if="!mixshowarray[2]"></el-input> 
        </div>
      </el-row>
      <el-row v-if="mixcountarray[3]">
        +
        <el-select v-model="mixfuncselectvalue[3]" :placeholder="$t('keyConfig.select')" style="width:200px" v-if="mixshowarray[3]">
          <el-option
            v-for="item in mixfuncoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input style="width:70px" type="text" v-model="mixtext[3]" maxlength="1" show-word-limit v-if="!mixshowarray[3]"></el-input>    
        <div style="display:inline-block;" v-if="mixcountarray[4]">
        +
        <el-select v-model="mixfuncselectvalue[4]" :placeholder="$t('keyConfig.select')" style="width:200px" v-if="mixshowarray[4]">
          <el-option
            v-for="item in mixfuncoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input style="width:70px" type="text" v-model="mixtext[4]" maxlength="1" show-word-limit v-if="!mixshowarray[4]"></el-input>  
        </div>
      </el-row>
      <el-row><label v-html="mixtips"></label></el-row>
      <div class="normal-key-lowercase-hint mix-key-hint">
        <i class="el-icon-info"></i>{{ $t('keyConfig.normalKeyLowercaseHint') }}
      </div>
      <el-row>        
        <el-button type="success" @click="mixadd(1)">{{ $t('keyConfig.mix1') }}</el-button>
        <el-button type="success" @click="mixadd(2)">{{ $t('keyConfig.mix2') }}</el-button>
        <el-button type="danger" @click="mixdelete()">{{ $t('keyConfig.mix3') }}</el-button>
        <el-button type="danger" @click="mixreset()">{{ $t('keyConfig.mix4') }}</el-button>
        <el-popover
        ref="popover"
        placement="left"
        width="630"
        trigger="click"
        v-show="commonshow">
        <div style="text-align: center;font-family: Helvetica, sans-serif;">
          <el-row style="margin-bottom: 10px;"><h4>{{ $t('keyConfig.mixtip') }}</h4></el-row>
          <el-row style="margin-bottom: 10px;">
          <el-table
          :data="tableData"
          height="600"
          style="width: 120%;"
          :header-cell-style="{textAlign: 'center'}"
          :cell-style="{textAlign: 'center'}" >
          <el-table-column
            prop="keys"
            :label="$t('keyConfig.mixcommon1')"
            width="250">
          </el-table-column>
          <el-table-column
            prop="description"
            :label="$t('keyConfig.mixcommon2')"
            width="250">
          </el-table-column>
          <el-table-column
            :label="$t('keyConfig.mixcommon3')"
            width="130">
            <template slot-scope="scope">
              <el-button type="success" size="small" @click="handleCommonClick(scope.row)">{{ $t('keyConfig.set') }}</el-button>
            </template>
          </el-table-column>
          </el-table>       
         </el-row>
        </div>        
        <el-button slot="reference" type="info" icon="el-icon-paperclip" style="margin-left: 10px;">{{ $t('keyConfig.mix5') }}</el-button>
      </el-popover>
      </el-row>
      </div>
    </div>
</template>

<script>
export default{
    props:{
        labelstr:'',        
        stringshow : true,
        mouseoptshow: {
            type: Boolean,
            default: true
        },
        mouseclickonly: {
            type: Boolean,
            default: false
        },
        mousedoubleEnable: {
            type: Boolean,
            default: false
        },
        stringsize: {
            type: Number,
            default: 30
        }
    },
    data(){
        return {
            keyname:'',
            keyradio:0,
            funcselectshow:false,
            mediaselectshow:false,
            input1show:false,
            input2show:false,
            mouseselectshow:false,
            mouseselectvalue:'',
            mouseoptions:[],
            mixshow:false,
            mediaselectvalue: '',
            funcoptions: [],
            funcselectvalue: '',
            mediaoptions: [],
            text1: '',
            text2: '',
            mixcount:0,
            mousescroolshow:false,
            mousescrool:0,
            mouseinputtxt:'',
            mouseshow:false,
            mousechecktxt:'',
            mousepresschecktxt:'',
            stringchecktxt:'',
            mouseinputshow:false,
            mousecheckshow:false,
            mousepresscheckshow:false,
            mousecheck:false,
            mousepresscheck:false,
            mousedouble:false,
            mousedoubleshow:false,
            mousedoubletxt:'',
            stringcheck:false,
            mouseinput:10,
            mixfuncoptions: [],
            mixfuncselectvalue: ['','','','',''],
            mixtext:['','','','',''],
            mixtips:'',
            mixcountarray:[false,false,false,false,false],
            mixshowarray:[false,false,false,false,false],
            mouses:this.$t('keyConfig.mouses'),
            functionkeys:this.$t('keyConfig.functionkeys'),
            functionkeyvalues:[0x80, 0x81, 0x82, 0x83, 0x84, 0x85, 0x86, 0x87, 0xDA, 0xD9, 0xD8, 0xD7, 0xB2, 0xB3, 0xB0, 0xB1, 0xD1, 0xD4, 0xD3, 0xD6, 0xD2, 0xD5, 0xC1, 0xCE, 0xCF, 0xD0, 0xDB, 0xC2, 0xC3, 0xC4, 0xC5, 0xC6, 0xC7, 0xC8, 0xC9, 0xCA, 0xCB, 0xCC, 0xCD, 0xF0, 0xF1, 0xF2, 0xF3, 0xF4, 0xF5, 0xF6, 0xF7, 0xF8, 0xF9, 0xFA, 0xFB, 0xED, 0xDC, 0xDD, 0xDE, 0xDF, 0xE0, 0xE1, 0xE2, 0xE3, 0xE4, 0xE5, 0xE6, 0xE7, 0xE8, 0xE9, 0xEA, 0xEB],
            mediakeys:this.$t('keyConfig.mediakeys'),
            mediakeyvalues:[0xB5, 0xB6, 0xB7, 0xCD, 0xB0, 0xE2, 0xE9, 0xEA, 0x6F, 0x70, 0x183, 0x18A, 0x192, 0x194, 0x223, 0x224, 0x225, 0x227, 0x22A, 0x30, 0x32, 0xB2, 0xB3, 0xB4, 0x19e],
            tableData: [],
            commonshow:false,
            quickPanelOpen: false,
            quickSearch: '',
            quickCategory: 'all',
            quickList: [],
            quickActiveId: null
        }
    },
    computed: {
        isText1Valid() {
            if (!this.text1 || this.text1.length !== 1) return false;
            var code = this.text1.charCodeAt(0);
            return code >= 0x20 && code <= 0x7E;
        },
        quickCategories() {
            const t = this.$t('keyConfig');
            const it = this.$i18n.messages[this.$i18n.locale].index;
            return [
                { value: 'all',     label: t.quickCategoryAll },
                { value: 'edit',    label: t.quickCategoryEdit },
                { value: 'system',  label: t.quickCategorySystem },
                { value: 'browser', label: t.quickCategoryBrowser },
                { value: 'office',  label: t.quickCategoryOffice },
                { value: 'word',    label: it.scGroupOfficeWord },
                { value: 'excel',   label: it.scGroupOfficeExcel },
                { value: 'ide',     label: t.quickCategoryIDE },
                { value: 'ai-chat', label: it.scGroupAIChat },
                { value: 'ai-code', label: it.scGroupAICode },
                { value: 'zoom',    label: t.quickCategoryZoom },
                { value: 'media',   label: t.quickCategoryMedia }
            ];
        },
        filteredQuickList() {
            const kw = (this.quickSearch || '').trim().toLowerCase();
            return this.quickList.filter(it => {
                const catOk = (this.quickCategory === 'all') || (it.category === this.quickCategory);
                if (!catOk) return false;
                if (!kw) return true;
                return (
                    (it.name || '').toLowerCase().indexOf(kw) >= 0 ||
                    (it.hotkey || '').toLowerCase().indexOf(kw) >= 0 ||
                    (it.searchText || '').toLowerCase().indexOf(kw) >= 0
                );
            });
        }
    },
    mounted() {
        this.keyname = this.labelstr + ':';
        this.buildQuickList();
    },
    methods:{
        buildQuickList(){
            const LCTRL  = 0x80;
            const LSHIFT = 0x81;
            const LALT   = 0x82;
            const LWIN   = 0x83;
            const RCTRL  = 0x84;
            const RSHIFT = 0x85;
            const RALT   = 0x86;
            const RWIN   = 0x87;
            const ENTER  = 0xB0;
            const INSERT = 0xD1;
            const DEL    = 0xD4;
            const HOME   = 0xD2;
            const END    = 0xD5;
            const ESC    = 0xB1;
            const TAB    = 0xB3;
            const CAPS   = 0xC1;
            const F1     = 0xC2;
            const F2     = 0xC3;
            const F3     = 0xC4;
            const F4     = 0xC5;
            const F5     = 0xC6;
            const F6     = 0xC7;
            const F7     = 0xC8;
            const F8     = 0xC9;
            const F9     = 0xCA;
            const F10    = 0xCB;
            const F11    = 0xCC;
            const F12    = 0xCD;
            const PRINTSCREEN = 0xCE;
            const PAGEUP = 0xD3;
            const PAGEDOWN = 0xD6;
            const UARROW = 0xDA;
            const DARROW = 0xD9;
            const LARROW = 0xD8;
            const RARROW = 0xD7;
            const BS     = 0xB2;
            const c_a = 0x61, c_b = 0x62, c_c = 0x63, c_d = 0x64, c_e = 0x65, c_f = 0x66, c_g = 0x67;
            const c_h = 0x68, c_i = 0x69, c_j = 0x6A, c_k = 0x6B, c_l = 0x6C, c_m = 0x6D, c_n = 0x6E;
            const c_o = 0x6F, c_p = 0x70, c_q = 0x71, c_r = 0x72, c_s = 0x73, c_t = 0x74, c_u = 0x75;
            const c_v = 0x76, c_w = 0x77, c_x = 0x78, c_y = 0x79, c_z = 0x7A;
            const c_0 = 0x30, c_1 = 0x31, c_2 = 0x32, c_3 = 0x33, c_4 = 0x34, c_5 = 0x35, c_6 = 0x36, c_7 = 0x37, c_8 = 0x38, c_9 = 0x39;
            const c_eq = 0x3D, c_sub = 0x2D, c_space = 0x20, c_dot = 0x2E, c_slash = 0x2F;
            const c_semi = 0x3B, c_tick = 0x60;
            const t = this.$i18n.messages[this.$i18n.locale].index;
            const mk = (id, cat, name, hotkey, mixArr, extraSearch='') => {
                const mix = [0xFF,0xFF,0xFF,0xFF,0xFF];
                let keyCount = 0;
                for (let i=0; i<Math.min(mixArr.length,5); i++) { mix[i] = mixArr[i]; keyCount++; }
                return { id, category: cat, name, hotkey, mix, keyCount, searchText: extraSearch };
            };
            const list = [];
            let idSeq = 0;
            // ===== 高频编辑 10 条（复制/粘贴/剪切... 优先展示） =====
            list.push(mk(idSeq++,'edit',    t.scCopy,          'Ctrl + C',         [LCTRL, c_c], 'copy 复制'));
            list.push(mk(idSeq++,'edit',    t.scPaste,         'Ctrl + V',         [LCTRL, c_v], 'paste 粘贴'));
            list.push(mk(idSeq++,'edit',    t.scCut,           'Ctrl + X',         [LCTRL, c_x], 'cut 剪切'));
            list.push(mk(idSeq++,'edit',    t.scUndo,          'Ctrl + Z',         [LCTRL, c_z], 'undo 撤销'));
            list.push(mk(idSeq++,'edit',    t.scRedo,          'Ctrl + Y',         [LCTRL, c_y], 'redo 重做 恢复'));
            list.push(mk(idSeq++,'edit',    t.scSelectAll,     'Ctrl + A',         [LCTRL, c_a], 'select all 全选'));
            list.push(mk(idSeq++,'edit',    t.scSave,          'Ctrl + S',         [LCTRL, c_s], 'save 保存'));
            list.push(mk(idSeq++,'edit',    t.scFind,          'Ctrl + F',         [LCTRL, c_f], 'find 查找'));
            list.push(mk(idSeq++,'edit',    t.scReplace,       'Ctrl + H',         [LCTRL, c_h], 'replace 替换'));
            list.push(mk(idSeq++,'edit',    t.scPrint,         'Ctrl + P',         [LCTRL, c_p], 'print 打印'));
            // ===== 视图缩放 3 条 =====
            list.push(mk(idSeq++,'zoom',    t.scZoomIn,        'Ctrl + +',         [LCTRL, c_eq], 'zoom in 放大 enlarge bigger font 字体'));
            list.push(mk(idSeq++,'zoom',    t.scZoomOut,       'Ctrl + -',         [LCTRL, c_sub], 'zoom out 缩小 reduce smaller'));
            list.push(mk(idSeq++,'zoom',    t.scZoomReset,     'Ctrl + 0',         [LCTRL, c_0], 'zoom reset 重置缩放 reset 100% 恢复'));
            // ===== 粘贴为数值 / 格式 / 填充等办公常用 =====
            list.push(mk(idSeq++,'office',  t.scPasteValue,    'Ctrl + Shift + V', [LCTRL, LSHIFT, c_v], 'paste value 粘贴成数值 special paste 选择性粘贴 excel wps office'));
            list.push(mk(idSeq++,'office',  t.scPasteFormat,   'Ctrl + Shift + C', [LCTRL, LSHIFT, c_c], 'paste format 粘贴格式 format painter 格式刷 复制格式'));
            list.push(mk(idSeq++,'office',  t.scPasteLink,     'Ctrl + Alt + V',   [LCTRL, LALT, c_v], 'paste link 粘贴为链接 hyperlink 超链接'));
            list.push(mk(idSeq++,'office',  t.scFillDown,      'Ctrl + D',         [LCTRL, c_d], 'fill down 向下填充 duplicate 复制上一行'));
            list.push(mk(idSeq++,'office',  t.scQuickSave,     'Ctrl + Shift + S', [LCTRL, LSHIFT, c_s], 'save as 另存为 export 导出'));
            list.push(mk(idSeq++,'office',  t.scFormulaBar,    'Ctrl + `',         [LCTRL, c_tick], 'formula bar 编辑栏 显示隐藏 excel wps'));
            list.push(mk(idSeq++,'office',  t.scPivotTable,    'Alt + N',          [LALT, c_n], 'pivot table 创建数据透视表 pivot excel alt n'));
            // ===== 系统窗口 12 条（快捷键参考 scGroupWin 全量） =====
            list.push(mk(idSeq++,'system',  t.scSwitchWin,     'Alt + Tab',        [LALT, TAB], 'switch window 切换窗口 app'));
            list.push(mk(idSeq++,'system',  t.scCycleApps,     'Alt + Esc',        [LALT, ESC], 'cycle apps 循环切换应用程序 alt escape'));
            list.push(mk(idSeq++,'system',  t.scDesktop,       'Win + D',          [LWIN, c_d], 'desktop 显示桌面 最小化所有窗口'));
            list.push(mk(idSeq++,'system',  t.scExplorer,      'Win + E',          [LWIN, c_e], 'explorer 打开文件管理器 我的电脑'));
            list.push(mk(idSeq++,'system',  t.scSearch,        'Win + S',          [LWIN, c_s], 'search 搜索 cortana'));
            list.push(mk(idSeq++,'system',  t.scLock,          'Win + L',          [LWIN, c_l], 'lock 锁定电脑 screen'));
            list.push(mk(idSeq++,'system',  t.scSettings,      'Win + I',          [LWIN, c_i], 'settings 打开设置 panel'));
            list.push(mk(idSeq++,'system',  t.scRun,           'Win + R',          [LWIN, c_r], 'run 运行 命令行 cmd 执行程序'));
            list.push(mk(idSeq++,'system',  t.scNewWin,        'Ctrl + N',         [LCTRL, c_n], 'new window 新建窗口 新窗口'));
            list.push(mk(idSeq++,'system',  t.scCloseWin,      'Alt + F4',         [LALT, F4], 'close window 关闭窗口 exit 退出'));
            list.push(mk(idSeq++,'system',  t.scFullscreen,    'F11',              [F11], 'fullscreen 全屏 退出全屏'));
            list.push(mk(idSeq++,'system',  t.scScreenshot,    'PrtSc',            [PRINTSCREEN], 'screenshot full 截图 全屏 printscreen'));
            list.push(mk(idSeq++,'system',  t.scSnipping,      'Win + Shift + S',  [LWIN, LSHIFT, c_s], 'screenshot region 截图 区域 截取 snip & sketch'));
            list.push(mk(idSeq++,'system',  t.scTaskManager,   'Ctrl + Shift + Esc',[LCTRL, LSHIFT, ESC], 'task manager 任务管理器 kill task 杀进程'));
            // ===== 文本富文本（scGroupText 全量） =====
            list.push(mk(idSeq++,'edit',    t.scBold,          'Ctrl + B',         [LCTRL, c_b], 'bold 加粗 font'));
            list.push(mk(idSeq++,'edit',    t.scItalic,        'Ctrl + I',         [LCTRL, c_i], 'italic 斜体'));
            list.push(mk(idSeq++,'edit',    t.scUnderline,     'Ctrl + U',         [LCTRL, c_u], 'underline 下划线'));
            list.push(mk(idSeq++,'edit',    t.scSelectWord,    'Ctrl + Shift + →', [LCTRL, LSHIFT, RARROW], 'select word 选中单词 扩选 right arrow 扩展选择'));
            list.push(mk(idSeq++,'edit',    t.scHome,          'Ctrl + Home',      [LCTRL, HOME], 'jump to home 文档开头 文件开始'));
            list.push(mk(idSeq++,'edit',    t.scEnd,           'Ctrl + End',       [LCTRL, END], 'jump to end 文档结尾 文件结束'));
            list.push(mk(idSeq++,'edit',    t.scDelete,        'Delete',           [DEL], 'delete 删除 后删'));
            // ===== 浏览器（scGroupBrowser 全量） =====
            list.push(mk(idSeq++,'browser', t.scNewTab,        'Ctrl + T',         [LCTRL, c_t], 'new tab 新建标签页 tab'));
            list.push(mk(idSeq++,'browser', t.scCloseTab,      'Ctrl + W',         [LCTRL, c_w], 'close tab 关闭标签页 close window'));
            list.push(mk(idSeq++,'browser', t.scSwitchTab,     'Ctrl + Tab',       [LCTRL, TAB], 'switch tab 切换标签页 下一个 tab'));
            list.push(mk(idSeq++,'browser', t.scReopenTab,     'Ctrl + Shift + T', [LCTRL, LSHIFT, c_t], 'reopen tab 恢复关闭标签页 undo close tab'));
            list.push(mk(idSeq++,'browser', t.scBookmark,      'Ctrl + D',         [LCTRL, c_d], 'bookmark 添加书签 收藏 favorite'));
            list.push(mk(idSeq++,'browser', t.scRefresh,       'F5',               [F5], 'refresh 刷新 reload 重新加载'));
            list.push(mk(idSeq++,'browser', t.scHardRefresh,   'Ctrl + F5',        [LCTRL, F5], 'hard refresh 强制刷新 清除缓存 clear cache'));
            list.push(mk(idSeq++,'browser', t.scGoBack,        'Alt + ←',          [LALT, LARROW], 'back 后退 返回上一页 history back'));
            list.push(mk(idSeq++,'browser', t.scGoForward,     'Alt + →',          [LALT, RARROW], 'forward 前进 下一页 history forward'));
            list.push(mk(idSeq++,'browser', t.scDevTools,      'F12',              [F12], 'developer tools 开发者工具 inspector console debug'));
            list.push(mk(idSeq++,'browser', t.scDevTools2,     'Ctrl + Shift + I', [LCTRL, LSHIFT, c_i], 'devtools 开发者工具 备选 chrome edge inspector element'));
            // ===== IDE / 编辑器（scGroupIDE 全量 + scGroupDev 补充） =====
            list.push(mk(idSeq++,'ide',     t.scDeleteLine,    'Ctrl + Shift + K', [LCTRL, LSHIFT, c_k], 'delete line 删除行 remove line'));
            list.push(mk(idSeq++,'ide',     t.scSelectNext,    'Ctrl + D',         [LCTRL, c_d], 'select next 选中下一个相同 多选相同 word'));
            list.push(mk(idSeq++,'ide',     t.scSelectAll,     'Ctrl + Shift + L', [LCTRL, LSHIFT, c_l], 'select all occurrences 选中所有相同 全部相同词 cursor vscode'));
            list.push(mk(idSeq++,'ide',     t.scMoveLine,      'Alt + ↑ / ↓',      [LALT, UARROW], 'move line 移动行上下 alt up down 整行移动'));
            list.push(mk(idSeq++,'ide',     t.scComment,       'Ctrl + /',         [LCTRL, c_slash], 'comment toggle 注释 取消注释 line comment block'));
            list.push(mk(idSeq++,'ide',     t.scRename,        'F2',               [F2], 'rename symbol 重命名 重命名变量 refactor'));
            list.push(mk(idSeq++,'ide',     t.scGlobalSearch,  'Ctrl + Shift + F', [LCTRL, LSHIFT, c_f], 'global search 全局搜索 find in files project'));
            list.push(mk(idSeq++,'ide',     t.scExplorer,      'Ctrl + Shift + E', [LCTRL, LSHIFT, c_e], 'file explorer 文件资源管理器 左侧 文件树'));
            list.push(mk(idSeq++,'ide',     t.scGoToLine,      'Ctrl + G',         [LCTRL, c_g], 'go to line 跳转到行 number line'));
            list.push(mk(idSeq++,'ide',     t.scGoToSymbol,    'Ctrl + Shift + O', [LCTRL, LSHIFT, c_o], 'go to symbol 跳转到符号 function variable outline'));
            list.push(mk(idSeq++,'ide',     t.scFormat,        'Shift + Alt + F',  [LSHIFT, LALT, c_f], 'format code 格式化代码 format document prettier indent'));
            list.push(mk(idSeq++,'ide',     t.scCommandPalette,'Ctrl + Shift + P',[LCTRL, LSHIFT, c_p], 'command palette 命令面板 vs code all commands'));
            list.push(mk(idSeq++,'ide',     t.scSuggest,       'Ctrl + Space',     [LCTRL, c_space], 'suggest trigger 触发建议 代码补全 intellisense autocomplete'));
            list.push(mk(idSeq++,'ide',     t.scQuickFix,      'Ctrl + .',         [LCTRL, c_dot], 'quick fix 快速修复 灯泡修复 bulb code action'));
            list.push(mk(idSeq++,'ide',     t.scToggleSidebar, 'Ctrl + B',         [LCTRL, c_b], 'toggle sidebar 切换侧边栏 activity bar 显示隐藏 左栏'));
            list.push(mk(idSeq++,'ide',     t.scDebug,         'F5',               [F5], 'start debugging 开始调试 debug run 运行'));
            list.push(mk(idSeq++,'ide',     t.scTerminal,      'Ctrl + `',         [LCTRL, c_tick], 'terminal 终端 命令行 terminal panel shell'));
            // ===== AI 对话聊天（scGroupAIChat 全量） =====
            list.push(mk(idSeq++,'ai-chat', t.scAIChatSubmit,  'Ctrl + Enter',     [LCTRL, ENTER], 'submit prompt 提交 发送 AI 生成 send message'));
            list.push(mk(idSeq++,'ai-chat', t.scAIChatNewline, 'Shift + Enter',    [LSHIFT, ENTER], 'new line 换行 不发送 多行输入 enter 不发送'));
            list.push(mk(idSeq++,'ai-chat', t.scAIChatClear,   'Ctrl + L',         [LCTRL, c_l], 'clear chat 清空对话 context 上下文 清空 chatgpt cursor'));
            list.push(mk(idSeq++,'ai-chat', t.scAIChatUndo,    'Ctrl + Shift + Z', [LCTRL, LSHIFT, c_z], 'undo ai 撤销上一轮 ai 生成 code 回滚'));
            list.push(mk(idSeq++,'ai-chat', t.scAIChatRetry,   'Ctrl + Shift + U', [LCTRL, LSHIFT, c_u], 'retry regenerate 重新生成 重试 ai 再次生成'));
            list.push(mk(idSeq++,'ai-chat', t.scAIChatStop,    'Esc',              [ESC], 'stop ai 停止生成 中断 AI 生成 cancel abort'));
            // ===== 选中代码后 AI 操作（scGroupAICode 全量） =====
            list.push(mk(idSeq++,'ai-code', t.scAICodeSidebar, 'Ctrl + K',         [LCTRL, c_k], 'ai sidebar 唤起 AI 侧边栏 解释修改选中代码 cursor chat'));
            list.push(mk(idSeq++,'ai-code', t.scAICodeInline,  'Ctrl + I',         [LCTRL, c_i], 'inline ai 行内 AI 编辑 补全 重构 cursor edit code inline'));
            list.push(mk(idSeq++,'ai-code', t.scAICodeSelectBlock,'Ctrl + Shift + L', [LCTRL, LSHIFT, c_l], 'select block 选中整段函数 代码块 select function cursor'));
            list.push(mk(idSeq++,'ai-code', t.scAICodeAccept,  'Tab',              [TAB], 'accept ai 接受 AI 补全 tab 采用 suggestion 单行'));
            list.push(mk(idSeq++,'ai-code', t.scAICodeReject,  'Shift + Tab',      [LSHIFT, TAB], 'reject ai 拒绝补全 回退 shift tab 取消 completion'));
            list.push(mk(idSeq++,'ai-code', t.scAICodeRefactor,'Ctrl + Shift + R', [LCTRL, LSHIFT, c_r], 'refactor ai 重构选中代码 优化逻辑 修复 bug refactor'));
            // ===== Office 通用（scGroupOfficeCommon 全量 + 缩放相关） =====
            const tw = this.$i18n.messages[this.$i18n.locale].index;
            list.push(mk(idSeq++,'office',  tw.scOfficeNewFile,    'Ctrl + N',         [LCTRL, c_n], 'office new 新建文件 wps word excel ppt'));
            list.push(mk(idSeq++,'office',  tw.scOfficeOpenFile,   'Ctrl + O',         [LCTRL, c_o], 'office open 打开文件 open document browse'));
            list.push(mk(idSeq++,'office',  tw.scOfficeSave,       'Ctrl + S',         [LCTRL, c_s], 'office save 保存 wps 保存文档'));
            list.push(mk(idSeq++,'office',  tw.scOfficeSaveAs,     'Ctrl + Shift + S', [LCTRL, LSHIFT, c_s], 'office save as 另存为 save a copy 导出'));
            list.push(mk(idSeq++,'office',  tw.scOfficePrint,      'Ctrl + P',         [LCTRL, c_p], 'office print 打印'));
            list.push(mk(idSeq++,'office',  tw.scOfficeCloseFile,  'Ctrl + W',         [LCTRL, c_w], 'office close 关闭当前文件 close document tab'));
            list.push(mk(idSeq++,'office',  tw.scOfficeUndo,       'Ctrl + Z',         [LCTRL, c_z], 'office undo 撤销'));
            list.push(mk(idSeq++,'office',  tw.scOfficeRedo,       'Ctrl + Y',         [LCTRL, c_y], 'office redo 重做 恢复'));
            list.push(mk(idSeq++,'office',  tw.scOfficeFind,       'Ctrl + F',         [LCTRL, c_f], 'office find 查找'));
            list.push(mk(idSeq++,'office',  tw.scOfficeReplace,    'Ctrl + H',         [LCTRL, c_h], 'office replace 替换 find & replace'));
            list.push(mk(idSeq++,'office',  tw.scOfficeFullScreen, 'F11 / Ctrl + F1',  [F11], 'office full screen 全屏显示 reading 阅读模式 alt w u'));
            list.push(mk(idSeq++,'office',  tw.scOfficeZoomPlus,   'Ctrl + 1',         [LCTRL, c_eq], 'office zoom in 放大视图 文档放大 bigger'));
            list.push(mk(idSeq++,'office',  tw.scOfficeZoomMinus,  'Ctrl + 2',         [LCTRL, c_sub], 'office zoom out 缩小视图 smaller reduce'));
            list.push(mk(idSeq++,'office',  tw.scOfficeZoom100,    'Ctrl + Alt + 0',   [LCTRL, RALT, c_0], 'office zoom 100% 缩放到100% 实际大小 actual size'));
            // ===== Word / WPS 文字（scGroupOfficeWord 全量） =====
            list.push(mk(idSeq++,'word',    tw.scWordNewDoc,         'Ctrl + N',          [LCTRL, c_n], 'word 新建文档 new document wps'));
            list.push(mk(idSeq++,'word',    tw.scWordOpenDoc,        'Ctrl + O',          [LCTRL, c_o], 'word 打开文档 open file docx doc'));
            list.push(mk(idSeq++,'word',    tw.scWordSaveAs,         'F12',               [F12], 'word 另存为 save as f12 export'));
            list.push(mk(idSeq++,'word',    tw.scWordFindNext,       'Shift + F4',        [LSHIFT, F4], 'word 查找下一处 find next repeat last search'));
            list.push(mk(idSeq++,'word',    tw.scWordGoToPage,       'Ctrl + G',          [LCTRL, c_g], 'word 定位 页码 goto page section bookmark'));
            list.push(mk(idSeq++,'word',    tw.scWordInsertLink,     'Ctrl + K',          [LCTRL, c_k], 'word 插入超链接 hyperlink 链接 url'));
            list.push(mk(idSeq++,'word',    tw.scWordInsertPageBreak,'Ctrl + Enter',      [LCTRL, ENTER], 'word 插入分页符 page break 分页'));
            list.push(mk(idSeq++,'word',    tw.scWordSelectPara,     'Ctrl + E',          [LCTRL, c_e], 'word 选中整个段落 select paragraph 段落 selection'));
            list.push(mk(idSeq++,'word',    tw.scWordCenterAlign,    'Ctrl + E',          [LCTRL, c_e], 'word 居中 center align paragraph 居中对齐'));
            list.push(mk(idSeq++,'word',    tw.scWordLeftAlign,      'Ctrl + L',          [LCTRL, c_l], 'word 左对齐 left align 左对齐段落'));
            list.push(mk(idSeq++,'word',    tw.scWordRightAlign,     'Ctrl + R',          [LCTRL, c_r], 'word 右对齐 right align 右对齐段落'));
            list.push(mk(idSeq++,'word',    tw.scWordJustifyAlign,   'Ctrl + J',          [LCTRL, c_j], 'word 两端对齐 justify 两端 分散对齐'));
            list.push(mk(idSeq++,'word',    tw.scWord1_5Line,        'Ctrl + 5',          [LCTRL, c_5], 'word 1.5倍行距 line spacing 1.5 lines 行间距'));
            list.push(mk(idSeq++,'word',    tw.scWordBold,           'Ctrl + B',          [LCTRL, c_b], 'word 加粗 bold'));
            list.push(mk(idSeq++,'word',    tw.scWordUnderline,      'Ctrl + U',          [LCTRL, c_u], 'word 下划线 underline'));
            list.push(mk(idSeq++,'word',    tw.scWordItalic,         'Ctrl + I',          [LCTRL, c_i], 'word 斜体 italic'));
            // ===== Excel / WPS 表格（scGroupOfficeExcel 全量） =====
            list.push(mk(idSeq++,'excel',   tw.scExcelSumAuto,          'Alt + =',              [LALT, c_eq], 'excel 自动求和 auto sum alt equal sigma 总计'));
            list.push(mk(idSeq++,'excel',   tw.scExcelFillRight,        'Ctrl + R',             [LCTRL, c_r], 'excel 向右填充 fill right 左格右填'));
            list.push(mk(idSeq++,'excel',   tw.scExcelFillDown,         'Ctrl + D',             [LCTRL, c_d], 'excel 向下填充 fill down 上方下填'));
            list.push(mk(idSeq++,'excel',   tw.scExcelPasteValue,       'Ctrl + Shift + V',     [LCTRL, LSHIFT, c_v], 'excel 粘贴成数值 paste value 仅值 不带格式'));
            list.push(mk(idSeq++,'excel',   tw.scExcelPasteFormat,      'Ctrl + Shift + C',     [LCTRL, LSHIFT, c_c], 'excel 粘贴格式 format painter 复制格式 格式刷'));
            list.push(mk(idSeq++,'excel',   tw.scExcelInsertRow,        'Ctrl + Shift + +',     [LCTRL, LSHIFT, c_eq], 'excel 插入行 insert row column 插行 插列'));
            list.push(mk(idSeq++,'excel',   tw.scExcelDeleteRow,        'Ctrl + -',             [LCTRL, c_sub], 'excel 删除行 delete row column 删行 删列'));
            list.push(mk(idSeq++,'excel',   tw.scExcelToggleFilter,     'Ctrl + Shift + L',     [LCTRL, LSHIFT, c_l], 'excel 开启筛选 filter 开关 自动筛选'));
            list.push(mk(idSeq++,'excel',   tw.scExcelGoToCell,         'F5',                   [F5], 'excel goto 定位 单元格 goto special 定位条件'));
            list.push(mk(idSeq++,'excel',   tw.scExcelNameBox,          'Ctrl + F3',            [LCTRL, F3], 'excel 跳转到名称框 name manager 名称管理器 define name'));
            list.push(mk(idSeq++,'excel',   tw.scExcelSelectAllRegion,  'Ctrl + A / Ctrl + *',  [LCTRL, c_a], 'excel 选中当前数据区域 select all data range 数据区域 全选'));
            list.push(mk(idSeq++,'excel',   tw.scExcelTodayDate,        'Ctrl + ;',             [LCTRL, c_semi], 'excel 插入当前日期 date today 今天 分号'));
            list.push(mk(idSeq++,'excel',   tw.scExcelNowTime,          'Ctrl + Shift + :',     [LCTRL, LSHIFT, c_semi], 'excel 插入当前时间 time now 冒号 现在'));
            list.push(mk(idSeq++,'excel',   tw.scExcelEditCell,         'F2',                   [F2], 'excel 编辑单元格 edit cell 进入编辑 单元格编辑'));
            list.push(mk(idSeq++,'excel',   tw.scExcelSwitchSheet,      'Ctrl + PageDown',     [LCTRL, PAGEDOWN], 'excel 切换工作表 switch sheet 下一个 sheet tab 切表'));
            list.push(mk(idSeq++,'excel',   tw.scExcelFreezePane,       'Alt + W',              [LALT, c_w], 'excel 冻结窗格 freeze pane 冻结首行 alt w f f'));
            this.quickList = list;
        },
        applyQuickSetting(item){
            if(!item || !item.mix || !item.mix.length) return;
            this.quickActiveId = item.id;
            if(item.keyCount === 1){
                // 单键项（F1、Delete、Esc 等）设为功能键模式
                this.setKey(item.mix[0], 0, 0xFF, '', []);
            } else {
                // 多键项设为组合键模式
                this.setKey(0xFF, 2, 0xFF, '', item.mix);
            }
        },
         setCommon(commonkeys){
          this.tableData.splice(0,this.tableData.length);
          for(var i=0;i<commonkeys.length;i++){
          let item ={};
          let keys='';
          for(var j=0;j<commonkeys[i].mixkeys.length;j++){
            let keylabel=false;
            for(var k=0;k<this.functionkeyvalues.length;k++){
                if(this.functionkeyvalues[k]==commonkeys[i].mixkeys[j]){
                  if(j!=0){
                    keys+='+ '
                  }
                  keys+=this.functionkeys[k]+' ';
                    keylabel=true;
                 }
              }
            if(!keylabel)          
            {
              if(j!=0){
                keys+='+ '
              }
              keys+=String.fromCharCode(commonkeys[i].mixkeys[j])+' ';              
            }
          }
          item.keys=keys;
          item.description=commonkeys[i].description;
          item.mixkeys=commonkeys[i].mixkeys;
          this.tableData.push(item);
        }
        if(commonkeys.length){
          this.commonshow=true;
        }
        },
        handleCommonClick(row){
          this.mixcount=row.mixkeys.length;
          this.mixcountchange();
          for(var i=0;i<row.mixkeys.length;i++){
            let keylabel=false;
            for(var k=0;k<this.functionkeyvalues.length;k++){
                if(this.functionkeyvalues[k]==row.mixkeys[i]){        
                    this.mixfuncselectvalue[i]=row.mixkeys[i];
                    keylabel=true;
                    this.mixshowarray[i]=true;
                 }
              }
            if(!keylabel)          
            {              
              this.mixtext[i]=String.fromCharCode(row.mixkeys[i]);
              this.mixshowarray[i]=false;         
            }
          }
          this.$refs.popover.doClose();
        },
        keyReset(){
          this.keyradio=0;
          this.funcselectshow=false;
          this.mediaselectshow=false;
          this.input1show=false;
          this.input2show=false;
          this.mixshow=false;
          this.mouseselectshow=false,
          this.mouseselectvalue='',
          this.mouseoptions=[],
          this.mediaselectvalue= '';
          this.funcoptions= [];
          this.funcselectvalue= '';
          this.mediaoptions= [];
          this.text1= '';
          this.text2= '';
          this.mousescroolshow=false,
          this.mousescrool=0,
          this.mouseinputtxt='',
          this.mouseshow=false,
          this.mousechecktxt='',
          this.mousepresschecktxt='',
          this.mouseinputshow=false,
          this.mousecheckshow=false,
          this.mousepresscheckshow=false,
          this.mousecheck=false,
          this.mousepresscheck=false,
          this.stringcheck=false,
          this.mouseinput=10,
          this.mixcount=0;
          this.mixfuncoptions=[];
          this.mixfuncselectvalue=['','','','',''];
          this.mixtext=['','','','',''];
          this.mixtips='';
          this.mixcountarray=[false,false,false,false,false];
          this.mixshowarray=[false,false,false,false,false];
        },
        setKey(key,keyfunc,keyf,customstr,keymix){
          switch(keyfunc){
                case 1://media
                  this.keyradio=3;
                  this.fucChange();
                  if(keyf==0xff){
                   this.mediaselectvalue=key;
                  }else{
                    let tmp=Number(keyf<<8)+Number(key);
                    this.mediaselectvalue=tmp;              
                  }
                  break;
                case 2://mix
                  this.mixcount=0;
                  this.keyradio=4;
                  this.fucChange();
                  for(var i=0;i<keymix.length;i++){
                      if(keymix[i]!=0xff){
                        this.mixcount++;
                        let tmplabel=true;
                        for(var j=0;j<this.functionkeyvalues.length;j++){
                          if(this.functionkeyvalues[j]==keymix[i]){
                            this.mixfuncselectvalue[i]=keymix[i];
                            this.mixshowarray[i]=true;
                            tmplabel=false;
                            break;
                          }
                        }
                        if(tmplabel){
                        this.mixshowarray[i]=false;
                        this.mixtext[i]=String.fromCharCode(keymix[i]);
                        }
                      }
                  }
                  this.mixcountchange();
                  break;
                case 3://string
                  this.keyradio=5;
                  this.fucChange();
                  this.text2=customstr;
                  if(keyf==0x00){
                    this.stringcheck = false;
                  }else if(keyf==0x01){
                    this.stringcheck = true;
                  }
                  break;
                case 4: //mouse click
                  this.keyradio=6;
                  if(keyf==0x00){
                    this.mousecheck = false;
                  }else if(keyf==0x01){
                    this.mousecheck = true;
                  }else if(keyf==0x02){
                    this.mousepresscheck = true;
                  }else if(keyf==0x03){
                    this.mousedouble = true;
                  }
                  if(key==0x01){
                    this.mouseselectvalue=1;
                  }else if(key==0x02){
                    this.mouseselectvalue=3;
                  }else if(key==0x04){
                    this.mouseselectvalue=2;
                  }                  
                  this.fucChange();       
                  break;
                case 5: //mouse move random
                  this.keyradio=6;       
                  this.mouseselectvalue=4;     
                  this.fucChange();       
                  break;
                case 6: //mouse move
                  this.keyradio=6;       
                  if(keyf==0x01){//up
                    this.mouseselectvalue=5;  
                  }else if(keyf==0x02){//down
                    this.mouseselectvalue=6;  
                  }else if(keyf==0x03){//left
                    this.mouseselectvalue=7;  
                  }else if(keyf==0x04){//right
                    this.mouseselectvalue=8;  
                  }                 
                  this.mouseinput=(key-31);
                  this.mousecheck = false;
                  this.fucChange();       
                  break;
                case 7: //mouse move hold
                  this.keyradio=6;       
                  if(keyf==0x01){//up
                    this.mouseselectvalue=5;  
                  }else if(keyf==0x02){//down
                    this.mouseselectvalue=6;  
                  }else if(keyf==0x03){//left
                    this.mouseselectvalue=7;  
                  }else if(keyf==0x04){//right
                    this.mouseselectvalue=8;  
                  }                 
                  this.mouseinput=(key-31);
                  this.mousecheck = true;
                  this.fucChange();       
                  break;
                case 8: //mouse scrool
                  this.keyradio=6;       
                  if(keyf==0x01){//up
                    this.mouseselectvalue=9;  
                  }else if(keyf==0x02){//down
                    this.mouseselectvalue=10;  
                  }         
                  if(key==1){
                  this.mousescrool=1;
                  }else if(key==5){
                  this.mousescrool=2;
                  }else if(key==20){
                  this.mousescrool=3;
                  }else if(key==60){
                  this.mousescrool=4;
                  }else if(key==100){
                  this.mousescrool=5;
                  }
                  this.fucChange();       
                  break;
                case 9: //mouse scrool hold
                  this.keyradio=6;       
                  if(keyf==0x01){//up
                    this.mouseselectvalue=9;  
                  }else if(keyf==0x02){//down
                    this.mouseselectvalue=10;  
                  }              
                  if(key==1){
                  this.mousescrool=1;
                  }else if(key==5){
                  this.mousescrool=2;
                  }else if(key==20){
                  this.mousescrool=3;
                  }else if(key==60){
                  this.mousescrool=4;
                  }else if(key==100){
                  this.mousescrool=5;
                  }
                  this.mousecheck = true;
                  this.fucChange();       
                  break;
                default://normal
                  let keylabel=false;
                  //function
                  for(var i=0;i<this.functionkeyvalues.length;i++){
                    if(this.functionkeyvalues[i]==key){
                      this.keyradio=2;
                      this.fucChange();
                      this.funcselectvalue=key;
                      keylabel=true;
                    }
                  }
                  if(!keylabel){//normal
                    this.keyradio=1;
                    this.fucChange();
                    this.text1=String.fromCharCode(key);
                  }
                  break;
              }
        },
        getResult(){
            let result={
                funcCode:0xff,
                keyCode:0xff,
                mediaExtraCode:0xff,
                mixCode:[0xff,0xff,0xff,0xff,0xff],
                stringCode:new Array(this.stringsize).fill(0xff)
            };
            switch(this.keyradio){
          case 1://normal
              if(this.text1.length!=1){
                this.$message.error(this.labelstr+this.$t('keyConfig.inputErr'));
                return;
              }
              let tmp=this.text1.charCodeAt(0);
                if(tmp<0||tmp>255){
                  this.$message.error(this.labelstr+this.$t('keyConfig.inputErr'));
                  return;
                }                
                result.keyCode=tmp;
                result.funcCode=0x00;                     
              break;
          case 2://function
              if(this.funcselectvalue==""){
                this.$message.error(this.labelstr+this.$t('keyConfig.selectErr'));
                return;
              }          
                result.keyCode=this.funcselectvalue;
                result.funcCode=0x00;     
              break;
          case 3://media
              if(this.mediaselectvalue==""){
                this.$message.error(this.labelstr+this.$t('keyConfig.selectErr'));
                return;
              }          
                result.keyCode=this.mediaselectvalue & 0xff;
                if(((this.mediaselectvalue>>8) & 0xff) !=0){
                  result.mediaExtraCode = (this.mediaselectvalue>>8) & 0xff;
                }
                result.funcCode=0x01;     
              break;
          case 4://mix
                if(this.mixcount<2){
                  this.$message.error(this.labelstr+this.$t('keyConfig.mixErr'));
                  return;
                }
                for(var i=0;i<this.mixcount;i++){
                    if(this.mixshowarray[i]){
                      if(this.mixfuncselectvalue[i]==""){
                        this.$message.error(this.labelstr+this.$t('keyConfig.mixErr1')+(i+1)+this.$t('keyConfig.mixErr2'));
                        return;
                      }  
                      result.mixCode[i]=this.mixfuncselectvalue[i];
                    }else{
                      if(this.mixtext[i].length!=1){
                        this.$message.error(this.labelstr+this.$t('keyConfig.mixErr1')+(i+1)+this.$t('keyConfig.mixErr3'));
                        return;
                      }
                      let tmp=this.mixtext[i].charCodeAt(0);
                      if(tmp<0||tmp>255){
                        this.$message.error(this.labelstr+this.$t('keyConfig.mixErr1')+(i+1)+this.$t('keyConfig.mixErr3'));
                        return;
                      }  
                      result.mixCode[i]=tmp;
                    }
                }                
                result.funcCode=0x02;
            break; 
          case 5://string
            if(this.text2.length==0){
                this.$message.error(this.labelstr+this.$t('keyConfig.textErr'));
                return;            
            }
            for(var i=0;i<this.text2.length;i++){
              if(this.text2.charCodeAt(i)<0||this.text2.charCodeAt(i)>255){
                this.$message.error(this.labelstr+this.$t('keyConfig.textErr1'));
                return;
              }
              result.stringCode[i]=this.text2.charCodeAt(i);
            }
            result.funcCode=0x03;
            result.mediaExtraCode= this.stringcheck?0x01:0x00;
            break;
         case 6://mouse
              if(this.mouseselectvalue==""){
                this.$message.error(this.labelstr+this.$t('keyConfig.selectErr'));
                return;
              }
              if(this.mouseselectvalue==1 || this.mouseselectvalue==2 || this.mouseselectvalue==3 ){ //click
                  if(this.mousedouble){
                    result.funcCode=0x04;
                    result.mediaExtraCode=0x03;
                  }else{
                    result.mediaExtraCode= this.mousecheck?0x01:0x00;
                    if(this.mousepresscheck){
                      result.mediaExtraCode=0x02;
                    }
                    result.funcCode=0x04;
                  }
                  if(this.mouseselectvalue==1){//left
                    result.keyCode=0x01;
                  }else if(this.mouseselectvalue==2){//middle
                    result.keyCode=0x04;
                  }else if(this.mouseselectvalue==3){//right
                    result.keyCode=0x02;
                  }
             }else if(this.mouseselectvalue==4){ //move random
                  result.funcCode=0x05;
             }else if(this.mouseselectvalue==5 || this.mouseselectvalue==6 || this.mouseselectvalue==7 || this.mouseselectvalue==8 ){ //move move 
                  result.funcCode= this.mousecheck?0x07:0x06;
                  if(this.mouseselectvalue==5){//up
                    result.mediaExtraCode = 0x01;
                  }else if(this.mouseselectvalue==6){//down
                    result.mediaExtraCode = 0x02;
                  }else if(this.mouseselectvalue==7){//left
                    result.mediaExtraCode = 0x03;
                  }else if(this.mouseselectvalue==8){//right
                    result.mediaExtraCode = 0x04;
                  }
                  result.keyCode = this.mouseinput + 31;
             }else if(this.mouseselectvalue==9 || this.mouseselectvalue==10){ //move scrool
                  result.funcCode= this.mousecheck?0x09:0x08;
                  if(this.mouseselectvalue==9){//up
                    result.mediaExtraCode = 0x01;
                  }else if(this.mouseselectvalue==10){//down
                    result.mediaExtraCode = 0x02;
                  }
                  if(this.mousescrool==1){
                    result.keyCode = 1;
                  }else if(this.mousescrool==2){
                    result.keyCode = 5;
                  }else if(this.mousescrool==3){
                    result.keyCode = 20;
                  }else if(this.mousescrool==4){
                    result.keyCode = 60;
                  }else if(this.mousescrool==5){
                    result.keyCode = 100;
                  }
   
              }
            break;
          default://none
          this.$message.error(this.labelstr+this.$t('keyConfig.setErr'));
          return;
      }
          return result;
        },
        fucChange(){
      switch(this.keyradio){
        case 1://normal
          this.input1show = true;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow=false;
          break;
        case 2://function
          this.input1show = false;
          this.funcselectshow = true;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow=false;
          this.funcoptions.splice(0,this.funcoptions.length);
          for(var i=0;i<this.functionkeys.length;i++){
            this.funcoptions.push({value:this.functionkeyvalues[i],label:this.functionkeys[i]});
          }
          break;
        case 3://media
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = true;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow=false;
          this.mediaoptions.splice(0,this.mediaoptions.length);
          for(var i=0;i<this.mediakeys.length;i++){
            this.mediaoptions.push({value:this.mediakeyvalues[i],label:this.mediakeys[i]});
          }
          break;
        case 4://mix
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = true;
          this.mouseselectshow = false;
          this.mouseshow=false;
          this.mixfuncoptions.splice(0,this.mixfuncoptions.length);
          for(var i=0;i<this.functionkeys.length;i++){
            this.mixfuncoptions.push({value:this.functionkeyvalues[i],label:this.functionkeys[i]});
          }
          this.mixcountchange();
          break;
        case 5://string
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = true;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow=false;
          this.stringchecktxt=this.$t('keyConfig.stringEnter')
          break;
        case 6://mouse
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = true;
          this.mouseshow=true;
          this.mouseoptions.splice(0,this.mouseoptions.length);
          var maxMouseOpt = this.mouseclickonly ? 3 : this.mouses.length;
          for(var i=0;i<maxMouseOpt;i++){
            this.mouseoptions.push({value:(i+1),label:this.mouses[i]});
          }
          this.mousecheckchange();
          break;
        default://none
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow=false;
          break;
      }
 
    },
    mixdelete(){
      if(this.mixcount<=0){
        this.$message.error(this.$t('keyConfig.delErr'));
        return;
      }
      this.mixcount--;
      this.mixfuncselectvalue[this.mixcount]='';
      this.mixtext[this.mixcount]='';
      this.mixcountchange();
    },
    mixadd(type){
      if(this.mixcount>=5){
        this.$message.error(this.$t('keyConfig.mixMaxErr'));
        return;
      }        
      if(type==1){
        this.mixshowarray[this.mixcount]=true;
      }else if(type==2){
        this.mixshowarray[this.mixcount]=false;
      }
      this.mixcount++;   
      this.mixcountchange();
    },
    mixreset(){
      this.mixcount=0;
      this.mixfuncselectvalue=['','','','',''];
      this.mixtext=['','','','',''];
      this.mixshowarray=[false,false,false,false,false];
      this.mixcountchange();
    },
    mixcountchange(){
      switch(this.mixcount){
        case 0:
          this.mixcountarray=[false,false,false,false,false];
          this.mixtips=this.$t('keyConfig.mixAdd');
          break;         
        case 1:
        this.mixcountarray=[true,false,false,false,false];
          this.mixtips=this.$t('keyConfig.mixAdd');
          break;
        case 2:
          this.mixcountarray=[true,true,false,false,false];
          this.mixtips=this.$t('keyConfig.mixMax5');
          break;
        case 3:
          this.mixcountarray=[true,true,true,false,false];
          this.mixtips=this.$t('keyConfig.mixMax5');
          break;
        case 4:
          this.mixcountarray=[true,true,true,true,false];
          this.mixtips=this.$t('keyConfig.mixMax5');
          break;
        case 5:
          this.mixcountarray=[true,true,true,true,true];
          this.mixtips=this.$t('keyConfig.mixMax5');
          break;
        default:
          this.mixcountarray=[false,false,false,false,false];
          this.mixtips=this.$t('keyConfig.mixAdd');
          break;
      }
    }, mousecheckchange(){
      this.mousecheckshow = false;
      this.mousepresscheckshow = false;
      this.mousedoubleshow = false;
      this.mouseinputshow = false;
      this.mousescroolshow = false;
      this.mousechecktxt="";
      this.mousepresschecktxt="";
      this.mousedoubletxt="";
      this.mouseinputtxt="";
        if(this.mouseselectvalue==1 || this.mouseselectvalue==2 || this.mouseselectvalue==3 ){ //click
          this.mousedoubleshow = this.mousedoubleEnable;
          this.mousedoubletxt = this.$t('keyConfig.doubleClick');
          this.mousecheckshow = true;
          this.mousechecktxt = this.$t('keyConfig.holdTip');
          this.mousepresscheckshow = true;
          this.mousepresschecktxt = this.$t('keyConfig.holdPressTip');
        }else  if(this.mouseselectvalue==5 || this.mouseselectvalue==6 || this.mouseselectvalue==7 || this.mouseselectvalue==8 ){ //move
          this.mousecheckshow = true;
          this.mouseinputshow = true;
          this.mousechecktxt = this.$t('keyConfig.holdTip');
          this.mouseinputtxt = this.$t('keyConfig.move');
        }else if(this.mouseselectvalue==9 || this.mouseselectvalue==10 ){ //scrool
          this.mousecheckshow = true;
          this.mousescroolshow = true;
          this.mousechecktxt = this.$t('keyConfig.holdTip');
          this.mouseinputtxt = this.$t('keyConfig.strong');
        }
    },
    mousecheckpress1(){
      if(this.mousecheck){
        this.mousepresscheck=false;
        this.mousedouble=false;
      }
    },
    mousecheckpress2(){
      if(this.mousepresscheck){
        this.mousecheck=false;
        this.mousedouble=false;
      }
    },
    mousedoublechange(){
      if(this.mousedouble){
        this.mousecheck=false;
        this.mousepresscheck=false;
      }
    },
    getKeyDescription(){
      let desc='';
      switch(this.keyradio){
        case 1:
          desc=this.text1||'';
          break;
        case 2:
          if(this.funcselectvalue){
            const idx=this.functionkeyvalues.indexOf(this.funcselectvalue);
            desc=idx>=0?this.functionkeys[idx]:'';
          }
          break;
        case 3:
          if(this.mediaselectvalue){
            const idx=this.mediakeyvalues.indexOf(this.mediaselectvalue);
            desc=idx>=0?this.mediakeys[idx]:'';
          }
          break;
        case 4:
          let mixParts=[];
          for(let i=0;i<this.mixcount;i++){
            if(this.mixshowarray[i]){
              const idx=this.functionkeyvalues.indexOf(this.mixfuncselectvalue[i]);
              mixParts.push(idx>=0?this.functionkeys[idx]:this.mixfuncselectvalue[i]);
            }else{
              mixParts.push(this.mixtext[i]);
            }
          }
          desc=mixParts.join('+');
          break;
        case 5:
          desc=this.text2.length>20?this.text2.substring(0,20)+'...':this.text2;
          break;
        case 6:
          if(this.mouseselectvalue>=1&&this.mouseselectvalue<=this.mouses.length){
            desc=this.mouses[this.mouseselectvalue-1];
          }
          break;
        default:
          desc='';
      }
      return desc||this.$t('keyConfig.notSet');
    },
    refreshText(){
      this.mouses=this.$t('keyConfig.mouses');
      this.functionkeys=this.$t('keyConfig.functionkeys');
      this.mediakeys=this.$t('keyConfig.mediakeys');
      this.fucChange();
    }
}
}
</script>
<style scoped>
.el-row {
    margin-bottom: 20px;
}
.key-config-wrapper {
    width: 100%;
}
.key-header-row {
    margin-bottom: 12px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}
.quick-toggle-col {
    margin-left: auto;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    align-self: flex-start;
    gap: 4px;
}
.quick-toggle-btn {
    flex-shrink: 0;
    font-weight: 700 !important;
    font-size: 17px !important;
    padding: 11px 24px !important;
    height: auto !important;
    min-width: 140px;
    border-radius: 8px !important;
    box-shadow: 0 3px 10px rgba(64, 158, 255, 0.3) !important;
    background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%) !important;
    border: 1.5px solid #B3D8FF !important;
    color: #FFFFFF !important;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 1px rgba(30, 80, 150, 0.2);
}
.quick-toggle-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 5px 16px rgba(64, 158, 255, 0.42) !important;
}
.quick-toggle-btn:active {
    transform: translateY(0);
}
.quick-toggle-hint {
    font-size: 12px;
    font-weight: 500;
    color: #606266;
    background: linear-gradient(135deg, #ECF5FF 0%, #F5F0FF 100%);
    border: 1px solid #D3E3FF;
    padding: 3px 11px;
    border-radius: 12px;
    line-height: 1.5;
    box-shadow: 0 1px 2px rgba(64, 158, 255, 0.08);
    white-space: nowrap;
}
.normal-key-lowercase-hint {
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    width: fit-content;
    font-size: 11px;
    color: #E6A23C;
    background: #FDF6EC;
    border: 1px solid #F5DAB9;
    padding: 4px 10px;
    border-radius: 4px;
    line-height: 1.5;
}
.normal-key-lowercase-hint .el-icon-info {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid #E6A23C;
    color: #E6A23C;
    font-size: 10px;
    margin-right: 5px;
    background: transparent;
}
.mix-key-hint {
    margin-top: 6px;
    margin-bottom: 12px;
}
.quick-setting-row {
    margin-bottom: 18px;
}
.quick-setting-card {
    margin-left: 56px;
    padding: 9px 11px 8px 11px;
    background: #FAFBFF;
    border: 1px solid #E4E9F5;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(90, 110, 170, 0.05);
}
.qs-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 14px;
    padding: 6px 4px 10px 4px;
    margin-bottom: 10px;
    border-bottom: 1px solid #E4E9F5;
}
.qs-title {
    font-size: 16px;
    font-weight: 700;
    color: #303133;
    display: flex;
    align-items: center;
    letter-spacing: 0.3px;
}
.qs-title i {
    color: #E6A23C !important;
    font-size: 17px;
    margin-right: 8px !important;
}
.qs-search {
    width: 400px;
    max-width: 100%;
}
.qs-search >>> .el-input__inner {
    border-radius: 6px !important;
    height: 38px !important;
    border: 1.5px solid #B3D8FF !important;
    font-weight: 600;
    font-size: 14px !important;
    padding: 0 14px !important;
    box-shadow: 0 1px 3px rgba(64, 158, 255, 0.1) inset;
}
.qs-search >>> .el-input__inner:focus {
    border-color: #409EFF !important;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15), 0 1px 3px rgba(64, 158, 255, 0.1) inset;
}
.qs-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 6px;
}
.qs-categories >>> .el-button {
    padding: 4px 9px !important;
    height: auto !important;
    font-weight: 500 !important;
    border-radius: 5px !important;
    font-size: 11px !important;
}
.qs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 6px;
    max-height: 320px;
    overflow-y: auto;
    padding: 5px 2px 5px 0;
}
.qs-grid::-webkit-scrollbar {
    width: 5px;
}
.qs-grid::-webkit-scrollbar-thumb {
    background: #C0C4CC;
    border-radius: 3px;
}
.qs-grid::-webkit-scrollbar-track {
    background: #F4F4F5;
    border-radius: 3px;
}
.qs-card {
    padding: 6px 8px 5px 8px;
    background: #FFFFFF;
    border: 1px solid #EBEEF5;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.18s ease;
    user-select: none;
    position: relative;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(100, 120, 180, 0.04);
}
.qs-card::before {
    content: "";
    position: absolute;
    top: 0; left: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(180deg, #409EFF 0%, #8B5CF6 100%);
}
.qs-card:hover {
    transform: translateY(-1px);
    border-color: #409EFF;
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.14);
    background: #F5FAFF;
}
.qs-card:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(64, 158, 255, 0.1);
}
.qs-card-active {
    border-color: #67C23A !important;
    background: #F0F9EB !important;
    box-shadow: 0 2px 8px rgba(103, 194, 58, 0.2) !important;
}
.qs-card-active:hover {
    border-color: #67C23A !important;
    background: #E8F8DF !important;
    box-shadow: 0 2px 10px rgba(103, 194, 58, 0.25) !important;
}
.qs-card-active::before {
    background: linear-gradient(180deg, #67C23A 0%, #52B415 100%) !important;
}
.qs-card-name {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    padding-left: 2px;
    margin-bottom: 4px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.qs-card-hotkey {
    font-size: 11px;
    font-weight: 500;
    color: #606266;
    background: #F5F7FA;
    border: 1px solid #E4E7ED;
    padding: 2px 7px;
    border-radius: 4px;
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: Consolas, "Courier New", Menlo, Monaco, monospace;
    margin-left: 2px;
    line-height: 1.4;
}
.qs-footer-tip {
    margin-top: 8px;
    padding: 6px 9px;
    background: #F4F6FB;
    border-radius: 5px;
    font-size: 11px;
    font-weight: 500;
    color: #606266;
    line-height: 1.55;
}
@media (max-width: 900px) {
    .quick-setting-card {
        margin-left: 0;
    }
    .qs-search {
        width: 100%;
    }
    .qs-grid {
        grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    }
    .quick-toggle-btn {
        min-width: auto;
        padding: 5px 12px !important;
        height: 32px !important;
        font-size: 12px !important;
    }
    .quick-toggle-hint {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/KeyConfig.vue